// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__1TmG0","container":"Loading_container__gdPHG","description":"Loading_description__1q84T"};